import { not_implemented } from '../asserts/utils_asserts';

export const get_extension_from_filename = (file_name: string): string => {
  return '.' + file_name.slice(((file_name.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
};

export function get_size_in_bytes_number(data: any): number {
  let out = 0;

  if (data === null || data === undefined || data === '') {
    return out;
  }

  if (data instanceof Error) {
    //do nothing
  } else if (data instanceof Uint8Array) {
    out = data.length;
  } else if (data instanceof ArrayBuffer) {
    out = data.byteLength;
  } else {
    debugger;
  }

  return out;
}

export function format_size(bytes: number, empty_string_for_zero: boolean = false): string {
  const KB_1 = 1024;
  const KB_10 = KB_1 * 10;

  const MB_1 = KB_1 * 1024;
  const MB_10 = MB_1 * 10;

  const GB_1 = MB_1 * 1024;

  let out = '';

  if (bytes == 0) {
    out = empty_string_for_zero ? '' : '0.00 KB';
  } else if (bytes <= KB_10) {
    let bytes_converted = (bytes / KB_1).to_fixed(2);

    out = bytes_converted == 0 && empty_string_for_zero ? 'kb' : `${bytes_converted} KB`;
  } else if (bytes <= MB_10) {
    out = `${(bytes / MB_1).toFixed(2)} MB`;
  } else {
    out = `${(bytes / GB_1).toFixed(2)} GB`;
  }

  return out;
}

//todo: move to server
export function to_blob_bytes(input: Buffer<ArrayBuffer>): Uint8Array {
  let out: Uint8Array;

  if (input instanceof Uint8Array) {
    out = input;
  } else if (Buffer.isBuffer(input)) {
    out = Buffer.from(input).to_bytes();
  } else {
    not_implemented();
  }

  return out;
}

export function gb_to_bytes(gigabytes: number): number {
  return gigabytes * 1024 * 1024 * 1024;
}

export function mb_to_bytes(megabytes: number): number {
  return megabytes * 1024 * 1024;
}

export function bytes_to_gb(bytes: number): number {
  return bytes / (1024 * 1024 * 1024);
}
